<div class="main-container lg-view" *ngIf="!isLoading">
    <h3>Documents proposal</h3>

    <div class="main-form">
        <form [formGroup]="formModel">
            <fieldset>
                <legend>{{ job?.jobName }}</legend>

                <mat-form-field>
                    <mat-label>Type</mat-label>
                    <input matInput formControlName="type" />
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Budget</mat-label>
                    <input matInput currencyMask
                        [options]="{ prefix: '', align: 'left', inputMode: 1, min: 0, max: 999999999 }"
                        formControlName="budget" (blur)="reformatBudgetOnBlur()"
                        (keypress)="validateNumberKey($event)" />
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Comment</mat-label>
                    <textarea matInput formControlName="comment" rows="5"></textarea>
                </mat-form-field>

                <div class="form-button-container">
                    <button mat-raised-button type="button" (click)="openSelectionPage()">Select documents</button>
                </div>

                <div class="files-list-container" *ngIf="chosenFiles.size">
                    <div class="file" *ngFor="let fileId of chosenFilesKeys">
                        <button mat-flat-button class="recommend"
                            (click)="recommendedId = recommendedId === fileId ? null : fileId">
                            <mat-icon [class.recommended]="recommendedId === fileId">star</mat-icon>
                        </button>
                        <div class="document-details-container">
                            <span>{{ chosenFiles.get(fileId).description?.trim() || chosenFiles.get(fileId).getName()
                                }}</span>
                            <span class="document-type" *ngIf="chosenFiles.get(fileId).type.trim()"> {{
                                chosenFiles.get(fileId).type }}</span>

                            <div class="input-container">
                                <input currencyMask [(ngModel)]="chosenFiles.get(fileId).proposalAmount"
                                    [options]="{ prefix: '', align: 'left', inputMode: 1, min: 0, max: 999999999 }"
                                    placeholder="Cost" [ngModelOptions]="{ standalone: true }" required pattern="\S+" />
                                <span *ngIf="!chosenFiles.get(fileId).proposalAmount">&lowast;</span>
                            </div>
                        </div>
                        <button mat-flat-button (click)="removeDocument(fileId)">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>
            </fieldset>
        </form>
    </div>
</div>

<div class="actions-container md-view">
    <ng-container
        *ngIf="!customerPreferences.preferences.isJobAutoSkipped && !customerPreferences.preferences.isNotificationDisabled">
        <action-button [icon]="ButtonIcons.Exit" [name]="'Back'" [subpage]="'../'"></action-button>
        <action-button [icon]="ButtonIcons.Submit" [name]="'Submit'" [clickAction]="submitProposal.bind(self)"
            [disabled]="formModel.invalid || !chosenFiles.size || isAnyDocumentWithoutAmount()"></action-button>
    </ng-container>

    <div class="actions-placeholder-message" *ngIf="customerPreferences.preferences.isNotificationDisabled || customerPreferences.preferences.isJobAutoSkipped">
        <span
            *ngIf="customerPreferences.preferences.isNotificationDisabled && !customerPreferences.preferences.isJobAutoSkipped">
            {{ ActionsPlaceholderSettings.NotificationDisabled }}</span>
        <span
            *ngIf="customerPreferences.preferences.isJobAutoSkipped && !customerPreferences.preferences.isNotificationDisabled">
            {{ ActionsPlaceholderSettings.JobAutoSkipped }}</span>
        <span
            *ngIf="customerPreferences.preferences.isNotificationDisabled && customerPreferences.preferences.isJobAutoSkipped">
            {{ ActionsPlaceholderSettings.BothDisabled }}</span>
    </div>
</div>